import { WxPayRequest } from "@/api/models/config/WxPayRequest";
import { CancelablePromise, OpenAPI, type Response } from "@/api";
import { WxPayResponse } from "@/api/models/config/WxPayResponse";
import { request as __request } from "../core/request";
import { Config } from "@/api/models/config/Config";
import { DeliveryRequest } from "@/api/models/config/DeliveryRequest";
import { DeliveryResponse } from "@/api/models/config/DeliveryResponse";

export class ConfigService {
  public static WxPay(body: WxPayRequest): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/admin/config/wx",
      body: body,
    });
  }

  public static WxPayGet(): CancelablePromise<WxPayResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/config/wx",
    });
  }

  public static Config(body: Config): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/admin/config",
      body: body,
    });
  }

  public static ConfigGet(): CancelablePromise<WxPayResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/config",
    });
  }

  public static Delivery(
    body: DeliveryRequest
  ): CancelablePromise<DeliveryResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/config/delivery",
      body: body,
    });
  }
}
